import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FilterSidebar = ({ onFilterChange }) => {
    const [minTransitDays, setMinTransitDays] = useState(10);
    const [maxTransitDays, setMaxTransitDays] = useState(113);
    const [directRoutes, setDirectRoutes] = useState(false);
    const [oneTransshipment, setOneTransshipment] = useState(false);
    const [multipleTransshipments, setMultipleTransshipments] = useState(false);
    const [showShippingLines, setShowShippingLines] = useState(false);

    const [startDate, setStartDate] = useState('06 May 2025');
    const [endDate, setEndDate] = useState('20 May 2025');

    const applyFilters = () => {
        onFilterChange({
            transitTime: {
                min: minTransitDays,
                max: maxTransitDays
            },
            shipmentType: {
                direct: directRoutes,
                oneTransshipment,
                multipleTransshipments
            },
            departureDate: {
                start: startDate,
                end: endDate
            }
        });
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="m-0 fw-bold">Filter</h6>
                <button className="btn btn-sm btn-link text-secondary">Clear</button>
            </div>

            <div className="mb-4">
                <h6 className="mb-3">Direct/Transshipment</h6>
                <div className="form-check mb-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="direct"
                        checked={directRoutes}
                        onChange={() => setDirectRoutes(!directRoutes)}
                    />
                    <label className="form-check-label d-flex justify-content-between" htmlFor="direct">
                        <span>Direct</span>
                        <span className="text-secondary">(5)</span>
                    </label>
                </div>

                <div className="form-check mb-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="oneTransshipment"
                        checked={oneTransshipment}
                        onChange={() => setOneTransshipment(!oneTransshipment)}
                    />
                    <label className="form-check-label d-flex justify-content-between" htmlFor="oneTransshipment">
                        <span>1 Transshipment</span>
                        <span className="text-secondary">(40)</span>
                    </label>
                </div>

                <div className="form-check mb-2">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="multipleTransshipments"
                        checked={multipleTransshipments}
                        onChange={() => setMultipleTransshipments(!multipleTransshipments)}
                    />
                    <label className="form-check-label d-flex justify-content-between" htmlFor="multipleTransshipments">
                        <span>2 and more</span>
                        <span className="text-secondary">(274)</span>
                    </label>
                </div>
            </div>

            <div className="mb-4">
                <h6 className="mb-3">Transit time</h6>
                <div className="row g-2 mb-2">
                    <div className="col-6">
                        <input
                            type="number"
                            className="form-control"
                            value={minTransitDays}
                            onChange={(e) => setMinTransitDays(parseInt(e.target.value))}
                            placeholder="Min days"
                        />
                    </div>
                    <div className="col-6">
                        <input
                            type="number"
                            className="form-control"
                            value={maxTransitDays}
                            onChange={(e) => setMaxTransitDays(parseInt(e.target.value))}
                            placeholder="Max days"
                        />
                    </div>
                </div>
                <input
                    type="range"
                    className="form-range"
                    min="0"
                    max="200"
                    value={maxTransitDays}
                    onChange={(e) => setMaxTransitDays(parseInt(e.target.value))}
                />
            </div>

            <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="m-0">Shipping lines</h6>
                    <button
                        className="btn btn-sm btn-link p-0 text-dark"
                        onClick={() => setShowShippingLines(!showShippingLines)}
                    >
                        <ChevronDown size={16} />
                    </button>
                </div>
            </div>

            <div className="mb-4">
                <h6 className="mb-3">Departure</h6>
                <div className="row g-2 mb-2">
                    <div className="col-6">
                        <input
                            type="text"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            placeholder="Start date"
                        />
                    </div>
                    <div className="col-6">
                        <input
                            type="text"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            placeholder="End date"
                        />
                    </div>
                </div>
                <input
                    type="range"
                    className="form-range"
                    min="0"
                    max="30"
                    value={15}
                />
            </div>
        </div>
    );
};

export default FilterSidebar;